import React from 'react';

const About = () => {
  const faqs = [
    {
      question: 'ما هي الخدمات التي تقدمها "رحال"؟',
      answer: 'نقدم خدمات سياحية مختلفة تشمل: مختلف الحجزات ( تذاكر السفر،الفنادق،الرحلات... ) ، تنظيم الرحلات و الجولات وفق الطلب ، خدمات العمرة والحج، والإقامة في فنادق تقدم خيارات طعام حلال .',
    },
    {
      question: 'هل تقدمون خدمات مخصصة للأفراد أو العائلات؟',
      answer: 'نعم، نقدم برامج مخصصة للأفراد والعائلات لضمان تلبية كافة احتياجاتهم.',
    },
    {
      question: 'كيف يمكنني حجز رحلة أو جولة مع "رحال"؟',
      answer: 'يمكنك حجز رحلتك عبر موقعنا الإلكتروني أو تطبيقنا او  من خلال التواصل معنا مباشرة عبر صفحة "تواصل معنا".',
    },
    {
      question: 'ما هي الدول التي تغطيها خدماتكم؟',
      answer: 'نغطي وجهات سياحية متنوعة حول العالم، مع تركيز خاص على الوجهات المناسبة للمسافرين المسلمين.',
    },
  ];

  return (
    <div className="bg-about-background bg-cover bg-center min-h-screen flex flex-col justify-center items-center">
      <div className="bg-gray-100 p-10 my-10 rounded-lg shadow-md w-full max-w-5xl ">
        <h1 className="text-4xl font-bold text-center mb-8 text-gray-800"> حول <span style={{fontFamily:'Reem Kufi'}} className='text-[#1cc752] text-5xl'>رحال </span> </h1>
        <p className=" text-lg font-bold text-right mb-4 text-gray-600">
          منصة "رحال" هي وجهتك الأولى للسياحة. نسعى لتوفير تجربة سياحية استثنائية 
          للمسافرين المسلمين حول العالم مع مراعاة القيم والمبادئ الإسلامية في خدماتنا.
        </p>
        <div className="text-lg font-bold mb-12 text-gray-600">
          <p>
            سواء كنت تخطط لرحلة عائلية، مغامرة فردية، أو رحلة روحانية للحج والعمرة، 
            "رحال" هنا لتلبية كل توقعاتك وضمان راحتك .
          </p>
        </div>
        <h2 className="text-3xl font-bold mb-6 text-gray-800">الأسئلة الشائعة</h2>
        <div className="space-y-6">
          {faqs.map((faq, index) => (
            <div key={index} className="p-4 border border-gray-300 rounded-lg shadow-sm">
              <h3 className="text-xl font-semibold text-[#1cc752] mb-2">{faq.question}</h3>
              <p className="text-gray-700">{faq.answer}</p>
            </div>
          ))}
        </div>
      </div>
      <footer className="my-8 font-bold text-center text-white">
        <p>&copy; 2024 منصة السياحة الحلال "رحال". جميع الحقوق محفوظة.</p>
      </footer>
    </div>
  );
};

export default About;
